import styled from 'styled-components';

import PlanTabLeftSectionComponent from './PlanTabLeftSectionComponent.jsx';
import PlanTabRightSectionComponent from './PlanTabRightSectionComponent.jsx';

const PlanTab = styled.div`
  position: relative;
  width: 100%;

  @media (max-width: 1300px) {
    top: inherit;
  }
`;

const PlanTabContainer = ({ createNewTilesDigest, toggleMonthCollapse }) => {
  return (
    <PlanTab className="plan-tiles-sections">
      <PlanTabLeftSectionComponent />
      <PlanTabRightSectionComponent
        createNewTilesDigest={createNewTilesDigest}
        toggleMonthCollapse={toggleMonthCollapse}
      />
    </PlanTab>
  );
};

export default PlanTabContainer;
